import React, { useContext, useReducer } from 'react';
import { AuthStatusContext } from '@trp-individual-investor-adv-disc/adv-shared';

import investmentProposalReducer, { initialState } from './reducer';
import InvestmentProposalContext from './context';
import CWVBanner from '../../components/CWVBanner/CWVBanner';
import AppWrapper from '../../components/AppWrapper/AppWrapper';
import InvestmentProposalHub from '../../components/Hub/InvestmentProposalHub/InvestmentProposalHub';

const InvestmentProposalContainer = ({location}) => {
    const [state, dispatch] = useReducer(investmentProposalReducer, initialState);
    const { status, applicationConfig } = useContext(AuthStatusContext).state;
    const isInternal = window.location.hostname.indexOf('.awstrp.net') !== -1;

    return (
        <InvestmentProposalContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            {isInternal && <CWVBanner
                planningGroup={state}
                showAdvHubBtn
            />}
            <AppWrapper status={status}>
                <InvestmentProposalHub
                    urlParam={location.search.includes('?delegateUser=') ?
                        location.search.split('?delegateUser=')[1].trim() :
                        undefined}
                    status={status}
                    applicationConfig={applicationConfig}
                />
            </AppWrapper>
        </InvestmentProposalContext.Provider>
    );
};

export default InvestmentProposalContainer;
